export const contactsData = {
  email: "gauravpathak346@gmail.com",
  phone: "+91 9838808612",
  address: "Varanasi, Uttar Pradesh, India",

  sheetAPI: "",
};
